import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  actionsloading: false
})

export function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_SETTINGS:
      return {
        ...state,
        actionsloading: true
      }
    case actionTypes.FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false
      }
    default:
      return state;
  }
}